import React, { useEffect, useRef, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";

import {
  FilterSection,
  ContentModerationTable,
  SearchBar,
} from "../../components/components";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import {
  drawerWidth,
  mainLayoutStyles,
  showNotification,
} from "../../../../../constants";
import { useContentModerationContext } from "../../../../../providers/GeneralAdmin/ContentModerationProvider";
import {
  contentReportsSearch,
  getFilterContentReports,
  updateContentReport,
} from "../../hooks/ContentReportsHooks";
import { Toast } from "../../../../../common/alert";
import FilterModalComponent from "../../../../../common/FilterModalComponent";
import { getDateRange } from "../../../../../modules/OrgProf/hook/Organizationhook";

const GAContentModerationContainer = () => {
  const { allContentReports, setLoading, loading, handleGetContentReports } =
    useContentModerationContext();

  const [contentReportsData, setContentReportsData] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [creationDateFilterOptions, setCreationDateFilterOptions] = useState(
    []
  );
  const [reportStatusFilterOptions, setReportStatusFilterOptions] = useState(
    []
  );
  const [reportTypeFilterOptions, setReportTypeFilterOptions] = useState([]);
  const [reportReasonFilterOptions, setReportReasonFilterOptions] = useState(
    []
  );

  useEffect(() => {
    // if (allContentReports?.length) {
    // } else {
    handleGetContentReports();
    // }
  }, []);

  console.log("allContentReports:", allContentReports);

  useEffect(() => {
    setContentReportsData(allContentReports);
  }, [allContentReports]);

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };
  const handleFilterModalClose = () => {
    setFilterModal(false);
  };

  const handleUpdateReportStatus = async (status) => {
    try {
      setLoading(true);
      const selectedReportDetails = allContentReports
        .filter((report) => selected.includes(report.id))
        .map((reportRecord) => reportRecord);

      for (const reportData of selectedReportDetails) {
        let statusTemp = {
          status,
          action: "Updated From Bulk Action",
          date: new Date(),
          notes: "Updated From Bulk Action",
        };
        let dataTemp = {
          status: statusTemp,
          statusHistory: [...reportData.statusHistory, statusTemp],
        };
        let responseTemp = await updateContentReport(reportData.id, dataTemp);
        console.log("update content report response:", responseTemp);
      }
      // selected.forEach(async (item) => {
      //   let responseTemp = await updateQuickTale(item, dataTemp);
      //   console.log("update quicktale response:", responseTemp);
      // });
      await handleGetContentReports();
      setSelected([]);
      showNotification("Content Report updated successfully.");
      // Toast("success", "Content Report updated successfully.");
    } catch (error) {
      Toast("error", error.message);
      console.log("error updating quicktale", error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterReports = async () => {
    let creationDateRange;
    if (creationDateFilterOptions && creationDateFilterOptions.length > 0) {
      creationDateRange = getDateRange(
        creationDateFilterOptions,
        "Creation Date"
      );
    }
    setSelected([]);
    if (
      creationDateFilterOptions.length > 0 ||
      reportStatusFilterOptions.length > 0 ||
      reportTypeFilterOptions.length > 0 ||
      reportReasonFilterOptions.length > 0
    ) {
      let temp = await getFilterContentReports(
        reportReasonFilterOptions,
        reportTypeFilterOptions,
        reportStatusFilterOptions,
        // creationDateFilterOptions,
        creationDateRange,
        setLoading,
        handleFilterModalClose
      );
      console.log("filter data:", temp);
      setContentReportsData(temp);
    }
    if (
      creationDateFilterOptions.length === 0 &&
      reportStatusFilterOptions.length === 0 &&
      reportTypeFilterOptions.length === 0 &&
      reportReasonFilterOptions.length === 0
    ) {
      setContentReportsData(allContentReports);
    }
  };

  const handleSearchReports = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let contentReportsSearchTemp = await contentReportsSearch(
          allContentReports,
          value
        );
        setContentReportsData(contentReportsSearchTemp);
      } else {
        setContentReportsData(allContentReports);
      }
    } catch (error) {
      console.log("error searching content reports:", error.message);
    }
  };

  const handleDeleteChip = (filterType, filterItem) => {
    if (filterType === "creationDate") {
      setCreationDateFilterOptions([]);
      // setCreationDateFilterOptions((prevOptions) =>
      //   prevOptions.filter((item) => item !== filterItem)
      // );
    } else if (filterType === "reportStatus") {
      setReportStatusFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "reportType") {
      setReportTypeFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    } else if (filterType === "reportReason") {
      setReportReasonFilterOptions((prevOptions) =>
        prevOptions.filter((item) => item !== filterItem)
      );
    }
  };

  useEffect(() => {
    handleFilterReports();
  }, [
    creationDateFilterOptions,
    reportStatusFilterOptions,
    reportTypeFilterOptions,
    reportReasonFilterOptions,
  ]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const resetFilter = async () => {
    setCreationDateFilterOptions([]);
    setReportStatusFilterOptions([]);
    setReportTypeFilterOptions([]);
    setReportReasonFilterOptions([]);
    setContentReportsData(allContentReports);
    setSelected([]);
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header mainTitle={"Content Moderation"} bgColor="#fff" />
      <GeneralAdminSidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection
            handleFilterModalOpen={handleFilterModalOpen}
            creationDateFilterOptions={creationDateFilterOptions}
            reportStatusFilterOptions={reportStatusFilterOptions}
            reportTypeFilterOptions={reportTypeFilterOptions}
            reportReasonFilterOptions={reportReasonFilterOptions}
            handleDeleteChip={handleDeleteChip}
          />
          <SearchBar
            selected={selected}
            setSelected={setSelected}
            placeholder={"Search"}
            handleSearch={handleSearchReports}
            handleUpdateReportStatus={handleUpdateReportStatus}
          />

          <ContentModerationTable
            selected={selected}
            setSelected={setSelected}
            contentReportsData={contentReportsData}
          />
        </Grid>
      </Grid>
      <FilterModalComponent
        modalOpen={filterModal}
        handleClose={handleFilterModalClose}
        resetFilter={resetFilter}
        handleFilter={handleFilterReports}
        data={[
          {
            mainOptions: creationDateFilterOptions,
            setMainOptions: setCreationDateFilterOptions,
            type: "date",
            title: "Creation Date",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Today", selected: false },
              { label: "Past Week", selected: false },
              { label: "Last 30 Days", selected: false },
              { label: "Last 12 Months", selected: false },
              { label: "Enter a Range", selected: false },
            ],
          },
          {
            mainOptions: reportStatusFilterOptions,
            setMainOptions: setReportStatusFilterOptions,
            type: "text",
            title: "Reported Status",
            currentOptions: [
              { label: "All", selected: true },
              { label: "reported", selected: false },
              { label: "in review", selected: false },
              { label: "resolved", selected: false },
              { label: "pending", selected: false },
            ],
          },
          {
            mainOptions: reportTypeFilterOptions,
            setMainOptions: setReportTypeFilterOptions,
            type: "text",
            title: "Reported Type",
            currentOptions: [
              { label: "All", selected: true },
              { label: "user", selected: false },
              { label: "quicktale", selected: false },
              { label: "organization", selected: false },
              { label: "reaction", selected: false },
            ],
          },

          {
            mainOptions: reportReasonFilterOptions,
            setMainOptions: setReportReasonFilterOptions,
            type: "text",
            title: "Reported Reason",
            currentOptions: [
              { label: "All", selected: true },
              { label: "Inappropriate content", selected: false },
              { label: "Violent Content", selected: false },
              { label: "Child sexual abuse or exploitation", selected: false },
              { label: "Harrassment or threats", selected: false },
              { label: "Fraud or spam", selected: false },
              { label: "Copyright infringement", selected: false },
              { label: "Other", selected: false },
            ],
          },
        ]}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default GAContentModerationContainer;
